import { jsxs as e, jsx as r } from "react/jsx-runtime";
import c from "./sectionBlock.module.js";
const a = ({
  title: s,
  children: o
}) => /* @__PURE__ */ e("div", { className: c["kcc-section-block"], children: [
  s && /* @__PURE__ */ r("span", { className: c.sectionHeader, children: s }),
  o
] });
export {
  a as SectionBlock
};
